import React, { Component } from 'react';

import Button from 'components/Button';
import Header from 'components/Header';

import './styles.css';

class NotFound extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="not-found">
        <Header light />

        <div className="info">
          <h1 className="info__title">Tokenblender closed</h1>
          <p className="info__paragraph">Unfortunatly Tokenblender is closed down. Sorry for the inconvenience.</p>
        </div>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/scenes/Closed/index.jsx